module.exports = __webpack_public_path__ + "897c5e876280d4cd9acd161fd2fd00ed.svg";